/* eslint-disable */
export default {
    categoryMenu: false,
    language: '',
    openCalendar: false
}